document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cart-item__qty-input").forEach((input) => {
    if (input.closest(".cart-qty-control")) {
      return;
    }

    const form = input.closest("form");
    const control = document.createElement("div");
    control.className = "cart-qty-control";

    const plus = document.createElement("button");
    plus.className = "cart-qty-button";
    plus.type = "button";
    plus.setAttribute("aria-label", "הגדלת כמות");
    plus.textContent = "+";

    const minus = document.createElement("button");
    minus.className = "cart-qty-button";
    minus.type = "button";
    minus.setAttribute("aria-label", "הקטנת כמות");
    minus.textContent = "−";

    input.parentNode.insertBefore(control, input);
    control.appendChild(plus);
    control.appendChild(input);
    control.appendChild(minus);

    const submitCart = () => {
      if (form?.requestSubmit) {
        form.requestSubmit();
      } else if (form) {
        form.submit();
      }
    };

    plus.addEventListener("click", () => {
      input.value = String((parseInt(input.value || "0", 10) || 0) + 1);
      submitCart();
    });

    minus.addEventListener("click", () => {
      const nextValue = Math.max(0, (parseInt(input.value || "0", 10) || 0) - 1);
      input.value = String(nextValue);
      submitCart();
    });
  });

  document.querySelectorAll(".metal-filters").forEach((group) => {
    const buttons = Array.from(group.querySelectorAll(".metal-filter"));
    const catalogGroup = group.closest(".catalog-group");
    const cards = Array.from(catalogGroup?.querySelectorAll(".product-card") || []);
    const countBadge = catalogGroup?.querySelector("[data-count]");

    const updateVisibility = (filter) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const metal = card.dataset.metal || "";
        const shouldShow = filter === "all" || metal === filter;
        card.hidden = !shouldShow;
        if (shouldShow) {
          visibleCount += 1;
        }
      });

      if (countBadge) {
        countBadge.textContent = `${visibleCount} פריטים`;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const filter = button.dataset.filter || "all";
        buttons.forEach((item) => item.classList.toggle("is-active", item === button));
        updateVisibility(filter);
      });
    });

    updateVisibility("all");
  });
});
